import React from 'react';

import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';

import { ViewByState } from '^/userWeb/Components/ViewByState';
import { routes } from '^/userWeb/routes';

import { defaultRecentCowStanzoneSlidesStyles } from './RecentCowStanzoneSlides.styles';
import { RecentCowStanzoneSlidesViewModel } from './RecentCowStanzoneSlides.viewmodel';

export const RecentCowStanzoneSlides: React.FC<{
  viewmodel: RecentCowStanzoneSlidesViewModel,
}> = observer(function RecentCowStanzoneSlides(p) {
  const styles = defaultRecentCowStanzoneSlidesStyles;
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      onClick={() => {
        routes
          .stanzoneListPage({})
          .push();
      }}
      tabIndex={0}
    >
      <ViewByState
        data={p.viewmodel.stanzoneStatsByCam}
        errorView={<p> err </p>}
        loadingView={<p> loading </p>}
      >
        {(statsByCam) => {
          return (
            <div
              className={styles.root}
            >
              {statsByCam
                .map((stats) => {
                  const lastCheckedTime = stats.latestHist.createdAt.toLocaleString();
                  if (stats.status === 'LOCKED_FOR_TOO_LONG') {
                    return (
                      <div
                        key={`${stats.camId}_LOCKED_FOR_TOO_LONG`}
                        className={styles.itemRoot}
                      >
                        <p
                          className={styles.camName}
                        >
                          🚨 {stats.camName}: 스탠존 너무 오래 잠김 🚨
                          <br />
                          <span className={styles.lastCheckedDatetime}>
                            마지막 확인 시간: <br /> {lastCheckedTime}
                          </span>
                        </p>
                        {stats.latestHist.imageUrl && (
                          <img
                            className={styles.image}
                            src={stats.latestHist.imageUrl}
                            alt={`${stats.camName} 스탠존 너무 오래 잠김:`}
                          />
                        )}

                      </div>
                    );
                  }
                  if (stats.status === 'LOCKED') {
                    return (
                      <div
                        key={`${stats.camId}_LOCKED`}
                        className={styles.itemRoot}
                      >
                        <p
                          className={styles.camName}
                        >
                          {stats.camName}: <br /> 스탠존 잠김 🔒
                          <br />
                          <span className={styles.lastCheckedDatetime}>
                            마지막 확인 시간: <br /> {lastCheckedTime}
                          </span>
                        </p>
                        {stats.latestHist.imageUrl && (
                          <img
                            className={styles.image}
                            src={stats.latestHist.imageUrl}
                            alt={`${stats.camName} 스탠존 잠김:`}
                          />
                        )}
                      </div>
                    );
                  }
                  return (
                    <div
                      key={`${stats.camId}_UNLOCKED`}
                      className={styles.itemRoot}
                    >
                      <p
                        className={styles.camName}
                      >
                        {stats.camName}: <br /> 스탠존 열림 ✅
                        <br />
                        <span className={styles.lastCheckedDatetime}>
                          마지막 확인 시간: <br /> {lastCheckedTime}
                        </span>
                      </p>
                      {stats.latestHist.imageUrl && (
                        <img
                          className={styles.image}
                          src={stats.latestHist.imageUrl}
                          alt={`${stats.camName} 스탠존 너무 오래 잠김:`}
                        />
                      )}
                    </div>
                  );
                })}
            </div>
          );
        }}
      </ViewByState>
    </div>
  );
});
